var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatsIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.85 56.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.3,3.07c-.97-.97-2.54-.97-3.51,0l-18.13,18.13-5.7-5.7c-.71-.71-1.78-.93-2.71-.54-.93.38-1.53,1.29-1.53,2.3v14.91c0,1.37,1.11,2.49,2.49,2.49h14.91c1,0,1.91-.6,2.3-1.53.39-.93.17-2-.54-2.71l-5.7-5.7L55.3,6.59c.97-.97.97-2.54,0-3.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.08,54.54H11.28c-4.11,0-7.46-3.35-7.46-7.46V12.29c0-4.11,3.35-7.46,7.46-7.46h19.89c1.37,0,2.49,1.11,2.49,2.49s-1.11,2.49-2.49,2.49H11.28c-1.37,0-2.49,1.11-2.49,2.49v34.8c0,1.37,1.12,2.49,2.49,2.49h34.8c1.37,0,2.49-1.11,2.49-2.49v-19.89c0-1.37,1.11-2.49,2.49-2.49s2.49,1.11,2.49,2.49v19.89c0,4.11-3.35,7.46-7.46,7.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsIn);
export default __webpack_public_path__ + "static/media/stats-in.48e50f4ea86d32c3f10c79309e88b56f.svg";
export { ForwardRef as ReactComponent };